import { getMaxError, getMinError } from 'src/utils/get-yup-errors';
import { object, string } from 'yup';

export const validationSchema = () =>
    object().shape({
        name: string().required('Name is required')
            .min(2, getMinError(2, 'Name'))
            .max(100, getMaxError(3, 'Name'))
    });